import {
  applyMiddleware,
  configureStore,
  getDefaultMiddleware
} from '@reduxjs/toolkit';
import localforage from 'localforage';
import { createMigrate, persistReducer } from 'redux-persist';
import logger from 'redux-logger';

import reducer from '../reducers';

const persistConfig = {
  key: 'root',
  storage: localforage,
  blacklist: ['perks', 'assetManager'],
  version: 0,
  migrate: createMigrate({
    // The full building list moved out of Redux; drop the stored copy.
    0: (state: any) => ({
      ...state,
      building: state?.building && { ...state.building, buildings: undefined }
    })
  })
};

const persistedReducer = persistReducer(persistConfig, reducer);

const devMiddleWare = process.env.NODE_ENV !== 'production' ? [logger] : [];

const store = configureStore({
  reducer: persistedReducer,
  middleware: [
    ...devMiddleWare,
    ...getDefaultMiddleware({ immutableCheck: false, serializableCheck: false })
  ],
  devTools: process.env.NODE_ENV !== 'production'
});

export type RootState = ReturnType<typeof store.getState>;

export type StoreDispatch = typeof store.dispatch;

export default store;
